module.exports = __webpack_public_path__ + "static/img/sucre.b1bb63b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departamentales/sucre.jpg
// module id = 03Dz
// module chunks = 1